import { NotificationType } from "@leedpulse-monorepo/enums";
import AI from '../AI';
import Notifications from '../Notifications';
import Scenario from '../Scenario';
import Subscription from '../Subscription';
import { IContact } from '@leedpulse-monorepo/interfaces';

export default class AugmentedNotifications {
  private _notifications: Notifications;
  private _contact: IContact;
  private _subscription?: Subscription;
  private _ai?: AI;
  private _scenario?: Scenario;

  constructor(
    notifications: Notifications,
    contact: IContact,
    subscription?: Subscription,
    ai?: AI,
    scenario?: Scenario
  ) {
    this._notifications = notifications;
    this._contact = contact;
    this._subscription = subscription;
    this._ai = ai;
    this._scenario = scenario;
  }

  get notifications(): Notifications {
    return this._notifications;
  }

  get contact(): IContact {
    return this._contact;
  }

  get subscription(): Subscription | undefined {
    return this._subscription;
  }

  get ai(): AI | undefined {
    return this._ai;
  }

  get scenario(): Scenario | undefined {
    return this._scenario;
  }

  // Getters to display on the lists
  get id(): string {
    return this._notifications.id;
  }
  get contactFullname(): string {
    return this._contact.contact.firstname + ' ' + this._contact.contact.lastname;
  }
  get contactFirstname(): string {
    return this._contact.contact.firstname;
  }
  get contactLastname(): string {
    return this._contact.contact.lastname;
  }
  get type(): NotificationType {
    return this._notifications.type;
  }
  get subscriptionName(): string | undefined {
    return this._subscription?.name;
  }
  
  get days(): number {
    return this._notifications.days;
  }
  get created(): Date {
    return this._notifications.created;
  }
  get updated(): Date {
    return this._notifications.updated;
  }

  get isSubscriptionAugmented(): boolean {
    return this._subscription !== undefined && this._subscription !== null;
  }

  get isAiAugmented(): boolean {
    return this._ai !== undefined && this._ai !== null;
  }

  get isScenarioAugmented(): boolean {
    return this._scenario !== undefined && this._scenario !== null;
  }

  // Copy with method to create a new instance with updated values
  public copyWith({
    notifications,
    contact,
    subscription,
    ai,
    scenario,
  }: {
    notifications?: Notifications;
    contact?: IContact;
    subscription?: Subscription;
    ai?: AI;
    scenario?: Scenario;
  }): AugmentedNotifications {
    return new AugmentedNotifications(
      notifications ?? this._notifications,
      contact ?? this._contact,
      subscription ?? this._subscription,
      ai ?? this._ai,
      scenario ?? this._scenario
    );
  }
}
